// extracted by mini-css-extract-plugin
export default {"card":"Q5-z"};